import { environment } from "../environments/environment";
const CLIENT_ID = environment.OKTA_CLIENT_ID;
const ISSUER = environment.OKTA_ISSUER;
const OKTA_TESTING_DISABLEHTTPSCHECK = !environment.production;
export default {
  oidc: {
    clientId: `${CLIENT_ID}`,
    issuer: `${ISSUER}`,
    redirectUri: `${window.location.origin}/implicit/callback`,
    scopes: ["openid", "profile", "email", "groups", "offline_access"],
    pkce: true,
    testing: {
      disableHttpsCheck: `${OKTA_TESTING_DISABLEHTTPSCHECK}`,
    },
  },
};

